enum BuildStatus {
  Running = 0,
  Success = 1,
  Error = 2,
  Aborted = 3,
  AbortedWithSuccess = 4,
}

export default BuildStatus;
